import { useEffect, useState } from 'react';
import { documentTableItem } from '../../../lib/models/interfaces';
import { Check } from 'lucide-react';
import { Toggle } from '@cloudscape-design/components';

interface DocumentCommentsProps {
  documents: documentTableItem[];
  carouselIndex: number;
}

export const PIIViewer = ({
  documents,
  carouselIndex
}: DocumentCommentsProps) => {
  const [prefView, setPrefView] = useState<string>('Document');
  const [checked, setChecked] = useState<boolean>(true);
  const [aggPii, setAggPii] = useState<string[]>([]);

  useEffect(() => {
    if (!checked) {
      const piiSet = new Set<string>();
      documents.forEach((doc) =>
        doc.entitiesDetected?.forEach((ent) => piiSet.add(ent))
      );
      setAggPii([...piiSet]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <div className="h-full min-h-[70vh]">
      <div className="w-full flex justify-end">
        <Toggle
          onChange={({ detail }) => {
            setChecked(detail.checked);
          }}
          checked={checked}
        >
          Single Document
        </Toggle>
      </div>
      {checked && (
        <div className="space-y-2">
          {documents[carouselIndex] &&
          documents[carouselIndex].entitiesDetected &&
          documents[carouselIndex]?.entitiesDetected!.length > 0 ? (
            <div
              className="space-y-2 overflow-y-scroll"
              style={{ scrollbarWidth: 'none' }}
            >
              <p className="text-2xl mb-2">
                {documents[carouselIndex].documentFileName}
              </p>
              {documents[carouselIndex].entitiesDetected!.map((ele) => {
                return (
                  <div className="border rounded-xl flex justify-between text-sm p-3">
                    <div>{ele}</div>
                    <div>
                      <Check color="green" />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-md border rounded-xl p-4 mt-4">
              No Sensitive Data found in this document.
            </div>
          )}
        </div>
      )}
      {!checked && (
        <div className="space-y-2">
          <p>Aggregate View</p>
          {aggPii.map((ent) => {
            return (
              <div className="border rounded-xl flex justify-between text-sm p-3">
                <div>{ent}</div>
                <div>
                  <Check color="green" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
